import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import {registerPlugin} from 'react-filepond';
import {Link} from 'react-router';

import KanbanColumn from './components/kanbanColumn';

registerPlugin(FilePondPluginImagePreview, FilePondPluginImageExifOrientation);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type kanbanBoardPropsT<T = any> = {
  columns: {
    id: string;
    title: string;
    items: T[];
  }[];
  isDark?: boolean;
  noHeader?: boolean;
  title?: string;
  CustomTaskComponent?: React.ComponentType<{
    item: T;
    isDark?: boolean;
  }>;
};

function Kanbanboard<T>({columns, isDark = true, noHeader = false, title, CustomTaskComponent}: kanbanBoardPropsT<T>) {
  return (
    <div className={`pt-4 ${!isDark ? 'bg-bodybg' : 'bg-bodybg2'}`}>
      {title && <h6 className="text-default mb-2 text-[1rem] font-semibold">{title}</h6>}
      {/* HEADER */}
      {!noHeader && (
        <div className="grid grid-cols-12 gap-x-6">
          <div className="col-span-12 xl:col-span-12">
            <div className="box">
              <div className="box-body p-4">
                <div className="flex-wrap items-center justify-between gap-4 md:flex">
                  <div className="grid grid-cols-12 gap-2 md:w-[30%]">
                    <div className="col-span-12 xl:col-span-5">
                      <Link
                        to="#"
                        className="hs-dropdown-toggle ti-btn bg-primary !font-medium text-white"
                        data-hs-overlay="#add-board"
                      >
                        <i className="ri-add-line !text-[1rem]"></i>New Board
                      </Link>
                    </div>
                    <div className="col-span-12 xl:col-span-7">
                      {/* <Select
                        name="colors"
                        options={Option1}
                        className="w-full !rounded-md"
                        menuPlacement="auto"
                        classNamePrefix="Select2"
                      /> */}
                    </div>
                  </div>
                  <div className="avatar-list-stacked my-3 md:my-0">
                    <span className="avatar avatar-rounded">
                      <img src={'/images/faces/2.jpg'} alt="img" />
                    </span>
                    <span className="avatar avatar-rounded">
                      <img src={'/images/faces/8.jpg'} alt="img" />
                    </span>
                    <span className="avatar avatar-rounded">
                      <img src={'/images/faces/2.jpg'} alt="img" />
                    </span>
                    <span className="avatar avatar-rounded">
                      <img src={'/images/faces/10.jpg'} alt="img" />
                    </span>
                    <span className="avatar avatar-rounded">
                      <img src={'/images/faces/4.jpg'} alt="img" />
                    </span>
                    <span className="avatar avatar-rounded">
                      <img src={'/images/faces/13.jpg'} alt="img" />
                    </span>
                    <Link className="avatar avatar-rounded bg-primary text-white" to="#">
                      +8
                    </Link>
                  </div>
                  <div className="flex" role="search">
                    <input
                      className="form-control me-2 w-full !rounded-sm"
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                    />
                    <button className="ti-btn ti-btn-light !mb-0" type="submit">
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="ynex-kanban-board text-defaultsize text-defaulttextcolor dark:text-defaulttextcolor/70">
        {columns &&
          columns.map((column, index) => (
            <KanbanColumn key={index} column={column} isDark={isDark} CustomTaskComponent={CustomTaskComponent} />
          ))}
      </div>
    </div>
  );
}

export default Kanbanboard;
